import React from 'react';
import {Modal} from "antd";
import {injectIntl} from "react-intl";
import BoldText from "../../common/text/BoldText";
import LabeledText from "../../common/text/LabeledText";

class RentalJourneyInfoModal extends React.Component {

  render() {
    const {intl: {formatMessage}, onModalClose, visible, rentalDetails} = this.props;
    if (!rentalDetails) {
      return null;
    }
    const {rentingJourney} = rentalDetails;

    return (
      <Modal title={formatMessage({id: 'section.car-park.modal.title'})}
             visible={visible} onCancel={onModalClose} footer={null}>
        <div className="row">
          <div className="list col-md-12 col-xxl-12">
            <LabeledText label={'summary.customer'} text={`${rentingJourney.customer.firstName} ${rentingJourney.customer.lastName}`}/>
          </div>
        </div>
        <div className="row">
          <div className="list col-md-12 col-xxl-12">
            <LabeledText label={'summary.phone'} text={rentingJourney.customer.phone}/>
          </div>
        </div>
        <div className="row">
          <div className="list col-md-12 col-xxl-12">
            <LabeledText label={'vehicle.vin'} text={<BoldText text={rentingJourney.vehicle.vin} boldEndCharacters={7}/>}/>
          </div>
        </div>
      </Modal>
    )
  }
}

export default injectIntl(RentalJourneyInfoModal);



// WEBPACK FOOTER //
// ./src/components/carpark/parkplanning/RentalJourneyInfoModal.js